import { BulkGoal, BulkGoalGroup, GoalGroupSection } from './types'

export const buildGoalGroupSections = (
  goals: BulkGoal[],
  groups: BulkGoalGroup[]
): GoalGroupSection[] => {
  const assignedGoalIds = new Set<string>()
  const sections = groups.flatMap(group => {
    const groupStoreIds = new Set(group.stores.flatMap(store => {
      if (typeof store === 'string') return [store]
      const storeId = store._id || store.id
      return storeId ? [storeId] : []
    }))
    const groupGoals = goals.filter(goal => {
      if (assignedGoalIds.has(goal._id) || !groupStoreIds.has(goal.store._id)) {
        return false
      }

      assignedGoalIds.add(goal._id)
      return true
    })

    return groupGoals.length > 0
      ? [{ id: group._id, name: group.name, goals: groupGoals }]
      : []
  })
  const ungroupedGoals = goals.filter(goal => !assignedGoalIds.has(goal._id))

  return ungroupedGoals.length > 0
    ? [...sections, { id: 'ungrouped', name: 'Lojas sem regional', goals: ungroupedGoals }]
    : sections
}
